import { z } from 'zod';
import { SchoolImage } from '@/model/School/SchoolImage.model';

export class School {
  constructor(
    public id: string,
    public name: string,
    public logoImage?: SchoolImage
  ) {
    this.id = id;
    this.name = name;
    if (logoImage) {
      this.logoImage = SchoolImage.fromJson(logoImage);
    }
  }

  public static zodSchema = z.object({
    id: z.string(),
    name: z.string(),
    logoImage: SchoolImage.zodSchema.optional(),
  });

  public static fromJson(json: unknown): School {
    const validJson = this.check(json);
    const school = new School(validJson.id, validJson.name, validJson.logoImage);
    return school;
  }

  public static fromJsonArray(jsonArray: unknown): School[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map((json) => new School(json.id, json.name, json.logoImage));
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }
}

export const mockSchool = School.fromJson({
  id: 'eddy',
  name: 'Eddy School',
});
